module.exports = __webpack_public_path__ + "static/vilson-46a0c42333bcd872e945fdabe64d9b00.jpg";